import PopoverController from './popover-controller';

export default PopoverController;
